import { z } from 'zod';
import { isoDateSchema, paginationSchema } from './common.ts';

export const RAISONS_MOUVEMENT = [
  'ACHAT',
  'VENTE',
  'CORRECTION',
  'RETOUR',
  'ANNULATION',
] as const;
export const raisonMouvementSchema = z.enum(RAISONS_MOUVEMENT);
export type RaisonMouvement = z.infer<typeof raisonMouvementSchema>;

export const RAISON_MOUVEMENT_LABELS: Record<RaisonMouvement, string> = {
  ACHAT: 'Achat',
  VENTE: 'Vente',
  CORRECTION: 'Correction',
  RETOUR: 'Retour',
  ANNULATION: 'Annulation',
};

export const mouvementListQuerySchema = paginationSchema.extend({
  product_id: z.string().trim().optional(),
  commande_id: z.string().trim().optional(),
  facture_id: z.string().trim().optional(),
  raison: raisonMouvementSchema.optional(),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
});
export type MouvementListQuery = z.infer<typeof mouvementListQuerySchema>;

export type Mouvement = {
  id: string;
  product_id: string;
  produit_nom: string | null;
  delta: number;
  raison: RaisonMouvement;
  facture_id: string | null;
  commande_id: string | null;
  note: string | null;
  created_at: string;
};
